const userSelector = (state: { [key: string]: any }) => state.user;
const roleSelector = (state: { [key: string]: any }) => state.role;
const orgSelector = (state: any) => state.org;
const loanSelector = (state: { [key: string]: any }) => state.loan;
const paymentSelector = (state: { [key: string]: any }) => state.payment;

export { userSelector, roleSelector, orgSelector, loanSelector, paymentSelector };
